import React from 'react'

import { Container, Divider, Picture, Text } from '@doist/marketist'

import { useTranslation } from 'next-i18next'

import css from './Manifesto.module.css'

function Manifesto() {
    const { t } = useTranslation('async')

    return (
        <Container className={css.container}>
            <Picture
                className={css.illustration}
                width={583}
                height={323}
                path="/assets/async/illustration_why_async_w_"
                sizes={[350, 792, 1140]}
            />
            <Text tag="h1" size="major-3xl">
                {t('title')}
            </Text>
            <Container className={css.copy}>
                <Text tag="p">{t('p1')}</Text>
                <Text tag="p">{t('p2')}</Text>
                <Text tag="p">{t('p3')}</Text>
                <Text tag="p">{t('p4')}</Text>
                <Text tag="p">{t('p5')}</Text>
                <Text tag="p">{t('p6')}</Text>
            </Container>
            <Text tag="h2" size="major-2xl">
                {t('subheader')}
            </Text>
            <Container className={css.copy}>
                <Text tag="p">{t('p7')}</Text>
                <Text tag="p">{t('p8')}</Text>
                <Text tag="p">{t('p9')}</Text>
                <Text tag="p">{t('p10')}</Text>
            </Container>
            <Divider separator />
        </Container>
    )
}

export { Manifesto }
